import type { ReactNode } from "react";

/** The kicker (orange eyebrow), crimson headline and sub-line every screen in the mock opens with. */
export function ScreenHeader({
  kicker,
  title,
  sub,
}: {
  kicker: string;
  title: string;
  sub?: ReactNode;
}) {
  return (
    <header className="mb-5">
      <div className="mb-2 text-[11px] font-bold uppercase tracking-[0.14em] text-kicker">
        {kicker}
      </div>
      <h1 className="mb-2 text-[26px] leading-[1.15] text-accent">{title}</h1>
      {sub ? <p className="m-0 max-w-[62ch] text-[14.5px] text-text-muted">{sub}</p> : null}
    </header>
  );
}
